var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'menu-item flex flex-row flex-nowrap items-center',
    'w-auto h-5 space-x-3 cursor-pointer',
    _vm.mobile ? 'justify-between' : 'justify-end' ],on:{"click":function($event){$event.preventDefault();return _vm.onLocaleSelect($event)},"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('span',{staticClass:"uppercase cursor-pointer align-middle"},[_vm._v(" "+_vm._s(_vm.locale.label)+" ")]),_c('div',{class:[
      'cursor-pointer h-4 relative transition-all radio-ring',
      { hover: _vm.isHovering } ]})])}
var staticRenderFns = []

export { render, staticRenderFns }